import { ItemLayoutSkeleton } from '@/shared/components'
import clsx from 'clsx'
import React from 'react'

interface PageHeaderWrapperProps {
  icon?: React.ReactNode
  title: React.ReactNode
  subtitle?: React.ReactNode
  actions?: React.ReactNode
  className?: string
  borderTitle?: boolean
  isLoading?: boolean
}

export const PageHeaderWrapper = ({
  icon,
  title,
  subtitle,
  actions,
  className = '',
  borderTitle,
  isLoading,
}: PageHeaderWrapperProps) => {
  return (
    <div
      className={clsx(
        'flex flex-col gap-4 md:pb-8',
        borderTitle
          ? 'border-b-0 md:border-b border-b-card-border dark:border-b-card-border-dark'
          : '',
        className
      )}
    >
      <div className="flex md:flex-row flex-col justify-start md:justify-between md:items-center gap-6 md:gap-2">
        {isLoading ? (
          <ItemLayoutSkeleton />
        ) : (
          <div className="flex items-start flex-col md:justify-center gap-2">
            <div className="flex gap-6">
              {icon}
              <span className="text-[20px] md:text-[32px] leading-[32px]">{title}</span>
            </div>
            <div className="flex flex-col justify-center gap-2">{subtitle && <>{subtitle}</>}</div>
          </div>
        )}

        {actions && <div className="flex gap-x-4">{actions}</div>}
      </div>
    </div>
  )
}
